import { useCallback, useMemo, useState } from 'react';
export function useCollapse(size) {
    const [items, setItems] = useState([]);
    const partial = useMemo(() => {
        return items.length === 0 || items.some(item => !item);
    }, [items]);
    const isCollapsed = useCallback((index) => !!items[index], [items]);
    const toggle = useCallback((index) => {
        setItems(items => {
            // collapse / expand all
            if (typeof index === 'undefined') {
                const collapse = items.length === 0 || items.some(item => !item);
                return Array(size).fill(collapse);
            }
            // toggle index
            const copy = Array.from(items);
            copy[index] = !copy[index];
            return copy;
        });
    }, [size]);
    return useMemo(() => {
        return { partial, isCollapsed, toggle };
    }, [partial, isCollapsed, toggle]);
}
//# sourceMappingURL=useCollapse.js.map